import React from 'react';
import './styles.scss';
import EpLocalLoading from '../EpLocalLoading';

const EpPageLoading = () => (
  <div className="page-loading__wrapper">
    <EpLocalLoading />
  </div>
);
export default EpPageLoading;
